var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon } from "../../UI";
import { removeNotification } from "../actions/notificationsActions";

export class Notification extends Component {
  close() {
    this.props.removeNotification(this.props.id);
  }

  render() {
    const { type, message } = this.props;
    const cssClass = `alert alert-${type}`;
    let icon = 'check';
    if (type === 'warning' || type === 'danger') {
      icon = 'exclamation-triangle';
    }

    const isNode = typeof message !== 'string';

    const FormattedMessage = isNode ?
    message :
    message.split('\n').map((item, i) => /*#__PURE__*/
    //eslint-disable-next-line react/no-array-index-key
    _jsx(React.Fragment, {}, i,
    item, /*#__PURE__*/
    _jsx("br", {})
    )
    );

    return /*#__PURE__*/(
      _jsx("div", { className: cssClass, onClick: this.close.bind(this) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: icon }), /*#__PURE__*/
      _jsx("span", { className: "alert-text" }, void 0, FormattedMessage), /*#__PURE__*/
      _jsx(Icon, { icon: "times" })
      ));

  }
}

Notification.defaultProps = {
  type: 'success'
};








function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeNotification }, dispatch);
}

export default connect(null, mapDispatchToProps)(Notification);